export enum EnrichLeadValuationType {
  RANGE = 'RANGE',
  SINGLE_VALUATION = 'SINGLE_VALUATION',
}
